export default function AgentCTA() {
  return (
    <section className="py-20 px-6 bg-gradient-to-br from-gray-900 to-gray-800">
      <div className="max-w-6xl mx-auto">
        {/* Main Content */}
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl lg:text-5xl font-bold text-white mb-6">
            Ready to Never Miss Another Lead?
          </h2>
          <p className="text-xl text-gray-300 mb-8 leading-relaxed max-w-2xl mx-auto">
            Pair your new content system with an AI voice agent that answers your calls 24/7 — even when you're in a showing.
          </p>
          
          <button className="bg-[#E8603C] text-white px-10 py-4 rounded-full text-lg font-semibold hover:bg-[#d14f2a] transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap inline-flex items-center gap-2">
            See How It Works
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
        </div>

        {/* Benefit Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-200">
            <div className="w-14 h-14 rounded-full bg-[#E8603C] flex items-center justify-center mb-6">
              <i className="ri-phone-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">
              24/7 Call Answering
            </h3>
            <p className="text-gray-300 text-base leading-relaxed">
              Never miss a lead. Your AI agent answers every call, even at 2am.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-200">
            <div className="w-14 h-14 rounded-full bg-[#E8603C] flex items-center justify-center mb-6">
              <i className="ri-calendar-check-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">
              Books Appointments
            </h3>
            <p className="text-gray-300 text-base leading-relaxed">
              Automatically schedules showings and consultations to your calendar.
            </p>
          </div>

          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 border border-white/20 hover:bg-white/15 transition-all duration-200">
            <div className="w-14 h-14 rounded-full bg-[#E8603C] flex items-center justify-center mb-6">
              <i className="ri-question-answer-line text-white text-2xl"></i>
            </div>
            <h3 className="text-xl font-bold text-white mb-3">
              Answers Questions
            </h3>
            <p className="text-gray-300 text-base leading-relaxed">
              Trained on your listings, services, and local market knowledge.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}